import React, { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import { DashboardNavBar } from 'src/components';

const DashboardLayout: React.FC = () => (
  <Fragment>
    <div style={{
      width : "calc(100% - 300px)"
    }}>
    <DashboardNavBar />
    <Outlet />
    </div>
  </Fragment>
);

export default DashboardLayout;
